import { useEffect, type ReactNode } from "react";
import { useHeaderAction } from "@/contexts/HeaderActionContext";

/** Register an action button in the global header. Cleans up on unmount. */
export function useRegisterHeaderAction(node: ReactNode) {
  const { setAction } = useHeaderAction();
  useEffect(() => {
    setAction(node);
    return () => setAction(null);
  }, [node, setAction]);
}
